<main>
  <div class="container">

    <div class="row mb-4">
      <div class="col general-title">
        @if (filtroMural=='S') {
          <h2>Mural de Comunicados</h2>
        }
        @if (filtroMural=='N') {
          <h2>Histórico de Avisos</h2>
        }
      </div>
    </div>

    <div class="filters pt-2 pt-lg-4 pl-2 pl-lg-4 pb-3 pb-lg-5">
      <div class="row w-100">
        <div class="col-auto p-0">
          <select [(ngModel)]="codAviTipo" (change)="onTipoChange()" class="text-center">
            <option selected value="0|S">-- Todos --</option>
            @for (item of tipos; track item) {
              <option [value]="item.COD_AVI_TIPO+'|'+item.DEC_OBRIGA_ACEITE">{{item.DCR_AVI_TIPO}}</option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="box table-responsive mb-4">
      <table class="table table-borderless table-hover">
        <thead>
          <tr>
            <th>Aviso</th>
            <th class="text-center px-2 px-md-5">Data Envio</th>
            @if (temAceite) {
              <th class="text-center px-2 px-md-5">Data Aceite</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of avisos; track item) {
            <tr [ngClass]="{'notread': item.DEC_ESCONDER=='N'}" (click)="openModalAViso(item); modalAviso.init(item)" style="cursor: pointer;">
              <td>
                <h4 class="title">{{item.TITULO}}
                  @if (item.COD_ARQ_GRUPO!=null) {
                    <span><i style="color: #848484;" class="fas fa-paperclip"></i></span>
                  }
                </h4>
                <p>{{ (item.DESCRICAO.length>6)? (item.DESCRICAO | slice:0:360)+'..': (item.DESCRICAO) }}</p>
              </td>
              <td class="text-center date px-2 px-md-5">
                {{item.TIM_HAB_INICIO| date:"dd/MM/yyyy HH:mm:ss"}}
              </td>
              @if (temAceite) {
                <td class="text-center date px-2 px-md-5">
                  {{item.TIM_ACEITE| date:"dd/MM/yyyy HH:mm:ss"}}
                </td>
              }
            </tr>
          }
        </tbody>
      </table>

    </div>

    <div class="text-center">
      @if (avisos.length >= numAviPagina && temMais && avisos.length > 0) {
        <button type="button" class="btn btn-link" (click)="carregarMais()">Carregar Mais</button>
      }
    </div>

  </div>

  <app-modal-aviso #modalAviso (onModalClose)="onCloseModalAviso()" modalID="modalAvisoNot"></app-modal-aviso>
</main>